import React from "react";

import Cleanup from "./Cleanup";
import Performance from "./Performance";

function AdvanceSettings(props) {
  return (
    <React.Fragment>
      <Cleanup />

      <Performance />
    </React.Fragment>
  );
}

export default AdvanceSettings;
